if (!customElements.get('yotpo-instagram-gallery')) {
  customElements.define(
    'yotpo-instagram-gallery',
    class YotpoInstagramGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        console.log('YotpoInstagramGallery component connected');
      }
    }
  );
}
